import { SegmentStrategy } from "../rules/intoSegments";
import { RuleSet } from "../rules/ruleSet";

export const pieToIpa: RuleSet = {
  inputSegments: SegmentStrategy.Single,
  outputSegments: SegmentStrategy.Ipa,
  rules: [
    { from: 'š', to: 'ʃ' },
    { from: 'ž', to: 'ʒ' },
    { from: 'ḍ', to: 'ɖ' },
    { from: 'ṛ', to: 'ɽ' },
    { from: 'ṣ', to: 'ʂ' },
    { from: 'ṭ', to: 'ʈ' },

    { from: 'ǣ', to: 'æː' },
    { from: 'á', to: 'aː' }, { from: 'ā', to: 'aː' },
    { from: 'é', to: 'eː' }, { from: 'ē', to: 'eː' },
    { from: 'í', to: 'iː' }, { from: 'ī', to: 'iː' },
    { from: 'ó', to: 'oː' }, { from: 'ō', to: 'oː' },
    { from: 'ú', to: 'uː' }, { from: 'ū', to: 'uː' },
    { from: 'ý', to: 'yː' }, { from: 'ȳ', to: 'yː' },
    { from: 'ă', to: 'a' },
    { from: 'ě', to: 'e' }, // old Slavonic palatalizing vowel
    { from: 'ę', to: 'ẽ' }, // old Slavonic
    { from: 'ŭ', to: 'u' }, // short back closed vowel of Proto-Slavic
    { from: 'ǵ', to: 'gʲ' },
    { from: 'ḱ', to: 'kʲ' },

    // guesses for the laryngeals
    { from: 'h₁', to: 'h' },
    { from: 'h₂', to: 'χ' },
    { from: 'h₃', to: 'ɣ' },
    { from: 'hₓ', to: 'h' },
    { from: 'ḫ', to: 'χ' }, // hittite laryngeal

    // used by the English-to-PIE dictionary
    { from: 'ǟ', to: 'áː' }, // long a + high-tone 
    { from: 'ṓ', to: 'óː' }, // long o + high-tone 
    { from: 'a̅', to: 'a' }, { from: 'e̅', to: 'e' },
    { from: 'ḿ', to: 'm' },
    { from: 'ŕ', to: 'r' },
  ],
  rules2: [
    // from oldEnglishRules, run after previous conversions
    // þ -> θ or ð
    { from: 'þþ', to: 'θθ' },
    { from: 'þ', to: 'θ', previous: ['#word'] },
    { from: 'þ', to: 'θ', previous: ['voiceless'] },
    { from: 'þ', to: 'θ', next: ['voiceless'] },
    { from: 'þ', to: 'ð', previous: ['vowel'], next: ['vowel'] },
    { from: 'þ', to: 'ð', previous: ['vowel'], next: ['voiced'] },
    { from: 'þ', to: 'ð', previous: ['voiced'], next: ['vowel'] },
    { from: 'þ', to: 'θ' },
  ]
};
